import React,{Component} from 'react';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {TextField} from '@material-ui/core';
import {bindActionCreators} from 'redux';
import {GetChartDetail} from '../../../Actions/chartAction';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker  from 'react-bootstrap-daterangepicker';
const styles={
  headerDate:{
    fontSize: '14px',
    marginTop:'5px',
    textAlign:'center',
    width:'200px'
  }
}
class DateCalender extends Component{
  constructor(){
    super();
    this.state={
      startDate:moment().format('MM/DD/YYYY'),
      endDate:'',
      isAllTime:false
    }
  }
  componentDidMount(){
    let {user}=this.props;
    let time=moment().format('LT');
    let startDate=`${moment().subtract(6,'days').format('MM/DD/YYYY')} 12:00:00 AM`;
    let endDate=moment().format('MM/DD/YYYY');
    //startDate=`${startDate} 12:00:00 AM`;
    endDate=`${endDate} ${time}`;
    this.props.GetChartDetail(user.results.BusinessUser.PlaceID,user.results.AppUser.UserId,moment(startDate).utc().format('MM-DD-YYYY hh:mm:ss A'),moment(endDate).utc().format('MM-DD-YYYY hh:mm:ss A'),false);
    this.setState({startDate:moment().subtract(6,'days').format('MM/DD/YYYY'),endDate:moment().format('MM/DD/YYYY')})
    this.displayDate();
  }
  handleEvent=(ev,picker)=>{
    const {user}=this.props;
    let time=moment().format('LT');
    let startDate=`${picker.startDate.format('MM/DD/YYYY')} 12:00:00 AM`;
    let endDate=picker.endDate.format('MM/DD/YYYY');
    //startDate=`${startDate} 12:00:00 AM`;
    let choosenLabel=picker.chosenLabel;
    if(choosenLabel==="Yesterday" || choosenLabel==="Last Month")
      endDate=`${endDate} 11:59:00 PM`;
    else if(choosenLabel==="Custom Range"){
      if(endDate>=moment().format('MM/DD/YYYY')){
        endDate=`${endDate} ${time}`
      }
      else
      {
        endDate=`${endDate} 11:59:00 PM`;
      }
    }
    else
      endDate=`${endDate} ${time}`
    if(picker.chosenLabel==="All time")
    {
      this.setState({isAllTime:true},()=>{
        this.props.GetChartDetail(user.results.BusinessUser.PlaceID,user.results.AppUser.UserId,moment(startDate).utc().format('MM-DD-YYYY hh:mm:ss A'),moment(endDate).utc().format('MM-DD-YYYY hh:mm:ss A'),this.state.isAllTime);
      })
    }
    else
      this.setState({isAllTime:false},()=>{
        this.props.GetChartDetail(user.results.BusinessUser.PlaceID,user.results.AppUser.UserId,moment(startDate).utc().format('MM-DD-YYYY hh:mm:ss A'),moment(endDate).utc().format('MM-DD-YYYY hh:mm:ss A'),this.state.isAllTime)
      });
    if(moment(startDate).format('MM/DD/YYYY')!==moment(endDate).format('MM/DD/YYYY'))
      this.setState({startDate,endDate})
    else
      this.setState({startDate,endDate:""})

    // }
    ev.preventDefault();
    ev.stopPropagation();
    // console.log('display date',this.state.startDate,this.state.endDate);
  }
  displayDate=()=>{
    let {endDate,startDate,isAllTime}=this.state;
    if(isAllTime)
    {
      return "All Time";
    }
    else {
      if (endDate === "") {
        return moment(startDate).format('MMM Do, YYYY').toString();
      }
      else if (moment(startDate).format('MMM Do, YYYY').split(' ')[0] === moment(endDate).format('MMM Do, YYYY').split(' ')[0]) {
        return `${moment(startDate).format('MMM Do, YYYY').split(",")[0]} - ${(moment(endDate).format('MMM Do, YYYY')).substring(4, 14)}`;
      }

      else if (moment(startDate).format('MMM Do, YYYY').split(' ')[0] !== moment(endDate).format('MMM Do, YYYY').split(' ')[0]) {
        return `${moment(startDate).format('MMM Do, YYYY').split(",")[0]} - ${(moment(endDate).format('MMM Do, YYYY').substring(0, 14))}`;
      }
    }

  }
  render(){

    const {classes}=this.props;

    return(
            <DateRangePicker startDate={moment(this.state.startDate)} endDate={this.state.endDate===""?moment(this.state.startDate):moment(this.state.endDate)}
                             ranges = {
                               {
                                 'Today': [moment(), moment()],
                                 'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                 'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                 'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                 'This Month': [moment().startOf('month'), moment()],
                                 'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                 'All time':[moment(), moment()]
                               } }
                             showCustomRangeLabel={true}
                             alwaysShowCalendars={true}
                             opens={'center'}
                             drops={'down'}
                             onApply={this.handleEvent}
                             applyClass="apply-btn"
                             linkedCalendars={false}
                             // buttonClasses={"button-css"}
            ><TextField
               InputProps={{
                 className:classes.headerDate
               }}
               inputProps={{
                 className:classes.headerDate
               }}
             value={this.displayDate()}/>
            </DateRangePicker>
    )
  }
}
const mapStateToProps=(state)=> {
  return {
    chartDetail:state.chartDetail,
    user:state.loginResponse
  }
};
const matchDispatchToProps=(dispatch)=> {
  return bindActionCreators({
    GetChartDetail
  },dispatch)
};
export default withStyles(styles)(connect(mapStateToProps,matchDispatchToProps)(DateCalender));